import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/styles";

export const TooltipWithArrow = withStyles(
  {
    tooltip: {
      "&:after": {
        borderColor: "transparent transparent transparent #fff",
        borderStyle: "solid",
        borderWidth: "8px 0 8px 10px",
        content: "' '",
        left: "100%",
        marginTop: -5,
        position: "absolute",
        top: "45%"
      },
      backgroundColor: "#fff",
      borderRadius: "20px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
      color: "#000",
      fontFamily: "inherit",
      fontSize: "1em",
      marginRight: 0,
      padding: "15px",
      position: "relative",
      right: 10
    }
  },
  { name: "TooltipWithArrow" }
)(Tooltip);
